import { render } from "./CenterBoard.vue?vue&type=template&id=c13068c6"
import script from "./CenterBoard.vue?vue&type=script&lang=js"
export * from "./CenterBoard.vue?vue&type=script&lang=js"

import "./CenterBoard.vue?vue&type=style&index=0&id=c13068c6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__